import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { SpecialistsPage } from './pages/SpecialistsPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { LanguageProvider } from './i18n/LanguageContext';
function AppContent() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);
  // Routing: EN has no prefix, other langs have /ru/, /ua/, /ka/ prefix
  // Page slugs: for-companies, for-seafarers
  const pathParts = currentPath.split('/').filter(Boolean);
  let page = '';
  const firstPart = pathParts[0] || '';
  if (['ru', 'ua', 'ka'].includes(firstPart)) {
    // Non-EN language: pathParts[0] is lang, pathParts[1] is page
    page = pathParts[1] || '';
  } else {
    // English (no prefix): pathParts[0] is page
    page = firstPart;
  }
  if (page === 'for-seafarers') {
    return <SpecialistsPage data-id="element-0" />;
  }
  if (page === 'for-companies') {
    return <CompaniesPage data-id="element-1" />;
  }
  return <HomePage data-id="element-2" />;
}
export function App() {
  return <LanguageProvider data-id="element-3">
      <AppContent data-id="element-4" />
    </LanguageProvider>;
}